import React from 'react';

import { useTranslation } from '@lt/localization';

import type { ModifierStyles } from 'src/routes/SeoApp/domain/state/modifier/types';
import styled from 'styled-components';

import { pluralizeHotels } from 'src/utils/pluralizeUtils';
import type { SearchType } from 'src/types/search';

export interface IHotelCounter {
  isMobile?: boolean;
  hotelCounter: number;
  modifierStyles?: ModifierStyles;
  searchType: SearchType;
  loading?: boolean;
}

export const HotelCounter = (props: IHotelCounter): JSX.Element | null => {
  const {
    isMobile = false,
    hotelCounter,
    modifierStyles,
    searchType,
    loading = false,
  } = props;
  const { t } = useTranslation();

  return isMobile ? null : (
    <StyledHotelCounter
      $textColor={modifierStyles?.textColor || 'var(--black)'}
    >
      {loading
        ? t('search.searchingToursTitle', {
            context: searchType,
          })
        : `${t('search.showToursTitle', {
            context: searchType,
          })} ${hotelCounter} ${pluralizeHotels(hotelCounter)}`}
    </StyledHotelCounter>
  );
};

const StyledHotelCounter = styled.div<{ $textColor: string }>`
  text-align: end;
  font-size: 14px;
  font-weight: 400;

  color: ${({ $textColor }) => $textColor};
`;
